import type { ResourceProps } from '@refinedev/core'
import { i18n } from '../../shared/i18n'

export const returnManagementResources: ResourceProps[] = [
  {
    name: 'return-management',
    meta: {
      label: i18n.t('navigation.returnManagement.label'),
    },
  },
  {
    name: 'return-list',
    list: '/returns',
    show: '/returns/:id',
    meta: {
      label: i18n.t('navigation.returnManagement.returnList'),
      parent: 'return-management',
    },
  },
]
